// There are no options for configuring message topics in Amwell's SDK, so
// we manually filter the ones we want to omit here. See DA-695 for details.
// TODO: Update implementation after Amwell updates their SDK to allow this.
export const bannedTopicKeys = [
  "enum.topictype.scheduleAppointment",
  "enum.topictype.referralRequest",
];
